import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHF,
	EnhancedDropDownRHFWithLabel,
	LabelPosition,
	RHookFormDatePicker,
	RHookFormNumberFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import React, { useEffect, useState } from "react";

import { Grid } from "@mui/material";
import { Link } from "react-router-dom";
import { values } from "lodash";

interface IWCBAllProvincesRemittanceHeader {
	remittanceFrequencyDDL: any
	wcbSavedFrequency: any
	defaultCodeDDL: any;
	onSubmitDefaultCodeHandler: (values: any) => void;
	onRemittanceFrequencyChangeHandler: (values: any) => void;
	onDefaultCodeDeleteClicked: () => void;
	onSavedDefaultCodeSelectionChangeHandler: (value: any) => void;
	savedWCBAllProvincesDDL: any;
	formMethods: any;
	onSavedWCBChangeHandler: (value: any) => void;
	setSelectedDefaultCodeProfile: (value: any) => void;
	wcbAllProvincesRemittanceSetup: any
	onExportButtonClick: () => void;
	defaultCodeProfileData: any
}

export const WCBAllProvincesRemittanceHeader: React.FC<
	IWCBAllProvincesRemittanceHeader
> = ({ defaultCodeDDL, onSubmitDefaultCodeHandler, onRemittanceFrequencyChangeHandler, remittanceFrequencyDDL,
	onDefaultCodeDeleteClicked,
	// onSavedDefaultCodeSelectionChangeHandler, 
	wcbSavedFrequency,
	savedWCBAllProvincesDDL,
	onSavedWCBChangeHandler,
	setSelectedDefaultCodeProfile,
	formMethods,
	wcbAllProvincesRemittanceSetup,
	onExportButtonClick,
	defaultCodeProfileData
}) => {
		const [selectedCode, setSelectedCode] = useState("new-rate");
		const onSavedDefaultCodeSelectionChangeHandler = (event: any) => {
			setSelectedDefaultCodeProfile(event.value)
			setSelectedCode(event.value)
			if (event.value === 'new-rate') {
				formMethods.setValue("rate", null)
				formMethods.setValue("description", "")
				formMethods.setValue("effectiveDate", null)
			} else {
				formMethods.setValue("rate", null)
				formMethods.setValue("description", "")
			}
		}

		useEffect(() => {
			if (defaultCodeProfileData) {
				setSelectedCode(defaultCodeProfileData.defaultCode)
			}
		}, [defaultCodeProfileData])
		return (
			<>
				<Grid
					container
					size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
					sx={{
						background: "#fff",
						border: "1px solid #e5e7eb",
						borderBottom: 0,
						borderRadius: "2px 2px 0 0",
						padding: "31px 20px 2.5rem 20px",
						marginBottom: "0px!important",
						color: "#4b5563",
					}} columnSpacing={2}>
					<Grid
						size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
						sx={{
							// "& .dropDownWrapper": { marginBottom: "38px!important", marginTop: "24px!important" },
							"& .dropDownWrapper": { marginBottom: "15px!important" },

						}}>
						<EnhancedDropDownRHFWithLabel
							selectName="remittanceFrequencyId"
							testId={`rqRemittanceFrequency-list`}
							items={remittanceFrequencyDDL ?? []}
							onSelectionChangeHandler={onRemittanceFrequencyChangeHandler}
							showEmpty
							selectedItem={null}
							isDisabled={wcbAllProvincesRemittanceSetup && wcbAllProvincesRemittanceSetup.items && wcbAllProvincesRemittanceSetup.items.some((item: any) => item.status === 'Remitted') ? true : false}
							label="WCB Remittance"
						/>
						<EnhancedDropDownRHFWithLabel
							selectName="savedWCBAllProvincesDDL"
							testId={`savedWCBAllProvincesDDL-list`}
							items={savedWCBAllProvincesDDL ?? []}
							onSelectionChangeHandler={onSavedWCBChangeHandler}
							showEmpty
							selectedItem={null}
							label="Saved WCB Profiles"
						/>
					</Grid>
					<Grid size={{ xs: 12, sm: 12, md: 1, lg: 1, xl: 1 }}></Grid>
					<Grid
						size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
						sx={{
							fontSize: "0.875rem",
							color: "#4b5563",
							"& .calenderWrapper ": { fontSize: ".875rem", marginBottom: "21px!important", width: "296px!important" },
							"& .MuiGrid-root ": { width: "296px!important", marginBottom: "0px!important" },
							"& .dropDownWrapper": { marginBottom: "15px!important" },
							"& .MuiTextField-root": { marginBottom: "15px!important" },
							"& .numberFieldWrapper": { marginBottom: "15px!important", width: "250px!important" },
						}}>
						<EnhancedDropDownRHFWithLabel
							selectName="defaultCode"
							items={defaultCodeDDL ?? []}
							label={"Default Code"}
							testId={"default-code"}
							onSelectionChangeHandler={onSavedDefaultCodeSelectionChangeHandler}
							selectedItem={'new-rate'}
						/>
						<RHookFormTextFieldWithLabel
							label="Descirption"
							id="description"
							testId={`description`}
							labelPosition={LabelPosition.Top}
							readOnly={selectedCode !== 'new-rate'}
						/>
						<Grid
							sx={{
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								"& .enhanced-button": {
									padding: '0.7rem 1.09375rem 0.69rem 1.09375rem !important',
									border: '1px solid #d1d5db',
									borderRadius: 0,
									marginTop: '9px',
									borderLeft: 0,
								}
							}}
						>
							<RHookFormNumberFieldWithLabel
								label={selectedCode === "new-rate" ? "Custom Rate" : "Rate"}
								id="rate"
								testId={`rq-rate`}
								readOnly={selectedCode !== 'new-rate'}
							/>
							<EnhancedButtonPrimeReact
								icon="pi pi-times"
								severity={EnhancedButtonPrimeReactSeverity.Danger}
								className="p-button-rounded p-button-text ml-2 shadow-none bg-transparent"
								rounded
								onClickHandler={
									onDefaultCodeDeleteClicked
								}
								disabled={selectedCode !== 'new-rate'}
							/>
						</Grid>
						<RHookFormDatePicker
							name="effectiveDate"
							testId="date-effective"
							label="Effective Date"
							labelPosition={LabelPosition.Top}
						/>
						<EnhancedButtonPrimeReact
							label="Save"
							raised
							onClickHandler={() => onSubmitDefaultCodeHandler(values)}
							severity={EnhancedButtonPrimeReactSeverity.Secondary}
						/>
					</Grid>
					<Grid size={{ xs: 12, sm: 12, md: 1, lg: 1, xl: 1 }}></Grid>
					<Grid
						size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}
						sx={{ fontSize: "0.875rem", textAlign: "Right", color: "#4b5563" }}
					>
						<Link
							to={"#"}
							className="no-underline"
						>
							<span style={{ color: "#0091b3" }}>All WCB Links would be defined here</span> <br />
						</Link>
						<Link
							to={"#"}
							className="no-underline"
							onClick={onExportButtonClick}
						>
							<span style={{ color: "#0091b3" }}>Export to Excel</span> <br />
						</Link>
					</Grid>
				</Grid >
			</>
		);
	};



